import React from "react";
import ReactDOM from "react-dom";

import Window from "./Window.js";
import CurveEdit from "../canvas/CurveEdit.js";

// const
// ]
// const startTime = keyframes[0].time;
// const duration = keyframes[keyframes.length - 1].time - startTime;

export default class CurveEditWindow extends Window {
  constructor(props) {
    super(props);
    this.ref = props.ref;
    this.keyframes = props.keyframes || {};
  }

  componentDidMount() {
    super.componentDidMount();
  }

  onProps() {
    return {
      width: 600,
      height: 400,
      draggable: true,
      position: {
        x: 500,
        y: 150
      },
      title: "Edit curve"
    };
  }

  onRender() {
    return (
      <CurveEdit
        className="mainCurveEditor"
        ref="curveEdit"
        key="curveEdit"
        property={"top"}
        width={500}
        height={200}
        keyframes={this.keyframes}
        onCurveUpdate={this.props.onCurveUpdate}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/windows/CurveEditWindow.js